import React from "react";
import "../componentsStyle.scss";
import {
  MapPin,
  Clock3,
  CheckCircle2,
  XCircle,
  Sparkles,
  Backpack,
  Lightbulb,
} from "lucide-react";
import { packages } from "../../constants/appConstats";
import { BookForm } from "./BookForm";

export const Timline = ({ data, languageId }) => {
  const tourData = packages?.find((el) => el?.id === data?.id);

  const timeLine = tourData?.itinerary?.timeline?.[languageId]?.items;
  const includes = tourData.itinerary.included?.[languageId]?.items;
  const whatToBring = tourData.itinerary.whatToBring?.[languageId]?.items;
  const highlights = tourData.itinerary.highlights?.[languageId]?.items;
  const notIncluded = tourData.itinerary.notIncluded?.[languageId]?.items;
  const tips = tourData.itinerary.tips?.[languageId]?.items;

  return (
    <div className="timeline-tour">
      {/* LEFT SIDE */}
      <div className="timeline-tour__content">
        {/* TIMELINE */}
        <div className="timeline-tour__timeline">
          <div className="timeline-line"></div>

          {timeLine?.map((item, index) => (
            <div className="timeline-item" key={index}>
              {/* ICON */}
              <div className="timeline-item__icon">
                <MapPin size={18} />
              </div>

              {/* CONTENT */}
              <div className="timeline-item__content">
                {item.time && (
                  <div className="timeline-item__time">
                    <Clock3 size={15} />
                    <span>{item.time}</span>
                  </div>
                )}

                <h3>{item.title}</h3>

                {item?.description?.length > 0 && (
                  <ul className="mt-3 space-y-2">
                    {item.description.map((line, idx) => (
                      <li
                        key={idx}
                        className="flex items-start gap-2 text-sm text-gray-600"
                      >
                        <span>{line}</span>
                      </li>
                    ))}
                  </ul>
                )}

                {/* <img src={item.image} alt={item.title} /> */}
              </div>
            </div>
          ))}
        </div>

        {/* DETAILS */}
        <div className="timeline-tour__details">
          {/* MAP */}
          <div className="map-card">
            <img
              src={
                tourData?.itinerary?.img ??
                "https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=1200&auto=format&fit=crop"
              }
              alt="Map"
            />

            {/* <div className="map-badge">
              <MapPin size={16} />
              Tour Route Map
            </div> */}
          </div>

          {/* INFO */}
          <div className="info-card">
            <div className="info-block">
              <h4>
                <Sparkles size={18} />
                Highlights
              </h4>

              <ul>
                {highlights.map((el) => (
                  <li>{el}</li>
                ))}
              </ul>
            </div>

            <div className="info-block">
              <h4>
                <CheckCircle2 size={18} />
                Includes
              </h4>

              <ul>
                {includes.map((el) => (
                  <li>{el}</li>
                ))}
              </ul>
            </div>

            {notIncluded?.length > 0 && (
              <div className="info-block">
                <h4>
                  <XCircle size={18} />
                  Not Included
                </h4>

                <ul>
                  {notIncluded.map((el) => (
                    <li>{el}</li>
                  ))}
                </ul>
              </div>
            )}

            {tips?.length > 0 && (
              <div className="info-block">
                <h4>
                  <Lightbulb size={18} />
                  Tips
                </h4>

                <ul>
                  {tips.map((el) => (
                    <li>{el}</li>
                  ))}
                </ul>
              </div>
            )}

            <div className="info-block">
              <h4>
                <Backpack size={18} />
                What to Bring
              </h4>

              <ul>
                {whatToBring.map((el) => (
                  <li>{el}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="timeline-tour__image" id="timeline">
        <BookForm
          price={tourData.price}
          packageTitle={tourData.title?.[languageId].label}
        />
      </div>
    </div>
  );
};
